module.exports = __webpack_public_path__ + "static/img/9.3ef2f87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/9.png
// module id = FAh3
// module chunks = 0